import React, { ComponentProps } from 'react'

import { Trans } from '@mc/i18n'
import { StyledFeatureVariable } from '@mc/feature-variables'

import { BOGO_I18N_NAMESPACE } from '../../../i18n'
import { BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME } from '../../constants'

type BannerOfferSloganBlueProps = Omit<
  ComponentProps<typeof StyledFeatureVariable>,
  'variableName' | 'defaultCopy' | 'variables' // Exclude the props being explicitly set
>

export const BannerOfferSloganBlue = (props: BannerOfferSloganBlueProps) => (
  <StyledFeatureVariable
    {...props}
    variableName={BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME}
    defaultCopy={
      <Trans i18nKey='banner.title' ns={BOGO_I18N_NAMESPACE}>
        <span className='mc-text-color--primary' />
      </Trans>
    }
    trackEV={true}
  />
)
